import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'react-toastify';
import { FiArrowLeft, FiUser, FiMapPin, FiEye, FiBell, FiShield, FiChevronRight, FiToggleLeft, FiToggleRight } from 'react-icons/fi';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 24 }}>
    <h3 style={{ fontSize: 11, fontWeight: 600, color: '#52525B', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 10, paddingLeft: 4 }}>{title}</h3>
    <div style={{ borderRadius: 16, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.04)', overflow: 'hidden' }}>
      {children}
    </div>
  </div>
);

const SettingsRow = ({ icon, label, value, toggle, toggled, onClick, color }) => (
  <button onClick={onClick} style={{
    display: 'flex', alignItems: 'center', gap: 14, width: '100%',
    padding: '14px 16px', background: 'none', border: 'none',
    cursor: 'pointer', fontFamily: 'Inter', textAlign: 'left',
    borderBottom: '1px solid rgba(255,255,255,0.03)',
  }}>
    <div style={{ width: 32, height: 32, borderRadius: 8, background: `${color || '#71717A'}12`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: color || '#A1A1AA' }}>
      {icon}
    </div>
    <span style={{ flex: 1, fontSize: 14, color: '#D4D4D8' }}>{label}</span>
    {toggle ? (
      toggled ? <FiToggleRight size={22} style={{ color: '#FF3D71' }} /> : <FiToggleLeft size={22} style={{ color: '#52525B' }} />
    ) : (
      <><span style={{ fontSize: 13, color: '#52525B' }}>{value}</span><FiChevronRight size={16} style={{ color: '#52525B' }} /></>
    )}
  </button>
);

const Settings = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [settings, setSettings] = useState({
    onlineStatus: true, readReceipts: true, matchNotif: true, messageNotif: true, likeNotif: true,
  });
  const toggle = (k) => setSettings(p => ({ ...p, [k]: !p[k] }));

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 32 }}>
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#A1A1AA', cursor: 'pointer' }}>
          <FiArrowLeft size={22} />
        </button>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Settings</h1>
      </div>

      <div style={{ padding: '0 20px' }}>
        <Section title="Account">
          <SettingsRow icon={<FiUser size={16} />} label="Edit Profile" color="#FF3D71" onClick={() => navigate('/edit-profile')} />
          <SettingsRow icon={<FiUser size={16} />} label="Phone Number" value="+91 98765" color="#3B82F6" />
          <SettingsRow icon={<FiUser size={16} />} label="Email" value="you@email.com" color="#8B5CF6" />
        </Section>

        <Section title="Discovery">
          <SettingsRow icon={<FiMapPin size={16} />} label="Location" value="Indore" color="#22C55E" />
          <SettingsRow icon={<FiMapPin size={16} />} label="Max Distance" value="50 km" color="#F59E0B" />
          <SettingsRow icon={<FiMapPin size={16} />} label="Age Range" value="18 - 35" color="#EC4899" />
          <SettingsRow icon={<FiEye size={16} />} label="Show Me" value="Everyone" color="#8B5CF6" />
        </Section>

        <Section title="Privacy">
          <SettingsRow icon={<FiEye size={16} />} label="Online Status" toggle toggled={settings.onlineStatus} onClick={() => toggle('onlineStatus')} color="#22C55E" />
          <SettingsRow icon={<FiEye size={16} />} label="Read Receipts" toggle toggled={settings.readReceipts} onClick={() => toggle('readReceipts')} color="#3B82F6" />
          <SettingsRow icon={<FiShield size={16} />} label="Profile Visibility" value="Visible" color="#FF3D71" />
        </Section>

        <Section title="Notifications">
          <SettingsRow icon={<FiBell size={16} />} label="Messages" toggle toggled={settings.messageNotif} onClick={() => toggle('messageNotif')} color="#FF3D71" />
          <SettingsRow icon={<FiBell size={16} />} label="New Matches" toggle toggled={settings.matchNotif} onClick={() => toggle('matchNotif')} color="#8B5CF6" />
          <SettingsRow icon={<FiBell size={16} />} label="Likes" toggle toggled={settings.likeNotif} onClick={() => toggle('likeNotif')} color="#EC4899" />
        </Section>

        <Section title="Security">
          <SettingsRow icon={<FiShield size={16} />} label="Photo Verification" value="Verified" color="#22C55E" />
          <SettingsRow icon={<FiShield size={16} />} label="Blocked Users" value="0" color="#EF4444" />
          <SettingsRow icon={<FiShield size={16} />} label="Change Password" color="#F59E0B" />
        </Section>
      </div>
    </div>
  );
};

export default Settings;
